<template>
	<div class="domeList">
        <tipheader :linTxt='linTxt' :maxtitle="maxtitle" :mintitle="mintitle" :ifimg="true" :pathUrl="listUrl" :borderNo='true'></tipheader>
		<!-- <topcon :maxtitle="maxtitle" :mintitle="mintitle" :pathUrl="listUrl"></topcon> -->

		<div class="alllist">
			<div class="signle" v-for="(item,index) in list" :key="index"
			@click="todetail(item)">
				<div class="f-row-start-b wrap w-100" v-if='type==1'>
                    <div class="title overfh" :title='item.title'>
                        {{item.title||''}}
                    </div>
                    <div class="date">{{item.pubTime.split(' ')[0] || ''}}</div>
                </div>
                <div class="f-row-start-b wrap w-100" v-if='type==2'>
                    <div class="title overfh" :title='item.compilationTitle'>
                        {{item.compilationTitle||''}}
                    </div>
                    <div class="date">{{item.publishTime.split(' ')[0] || ''}}</div>
                </div>
                <div class="f-row-start-b wrap w-100" v-if='type==3'>
                    <div class="title overfh" :title='item.title'>
                        {{item.title||''}}
                    </div>
                    <div class="date">{{item.createTime.split(' ')[0] || ''}}</div>
                </div>
			</div>
		</div>

	</div>

</template>

<script>

// import topcon from "../com/topcon.vue";
import tipheader from "../com/tipheader.vue";
export default {
  props:['maxtitle','mintitle','listUrl','detailUrl','pageSize','borderNo','linTxt'],
  components: {
   	// topcon,
    tipheader
  },

  data: function() {
    return {
		list:[],
        type:1,
    };
  },

  mounted() {
		this.getList()
  },

  methods: {
        getlistb(infoType){//最新通知
            this.$get(`web/info/list?pageSize=${this.pageSize}&pageNo=1&infoType=${infoType}`).then(res=>{
                if(res.success){
                    this.list = res.result.records
                }
            })
		},
        getStudyList(){//学习资料详情列表?studyType=1&pageSize=8&pageNo=1
            this.$get(`web/info/studyData?studyType=1&pageSize=${this.pageSize}&pageNo=1`).then(res=>{
                if(res.success){
                    this.list = res.result.records;
                }
            })
		},
          getFileList(){//学习资料详情列表?studyType=1&pageSize=8&pageNo=1
              this.$get(`web/info/fileData?dataType=0&pageSize=${this.pageSize}&pageNo=1`).then(res=>{
                  if(res.success){
                      this.list = res.result.records;
                  }
              })
          },
		getList(){
			  if(this.maxtitle+this.mintitle=='最新通知'){
                  this.type=1
                  this.getlistb(1)
              }
              if(this.maxtitle+this.mintitle=='各地动态'){
                  this.type=1
                  this.getlistb(6)
              }
              if(this.maxtitle+this.mintitle=='学习资料'){
                  this.type=2
                  this.getStudyList()
              }
            if(this.maxtitle+this.mintitle=='文件资料'){
                this.type=3
                this.getFileList()
            }
		},

		todetail(item){
			this.$router.push({ path:`${this.detailUrl}&id=${item.id}`});
		}

  },



};
</script>

<style scoped=" scoped" lang="scss">

.domeList{

	.alllist{
		margin-top:30px;
		min-height: 320px;
		.signle{
			// display: flex;
			// align-items: center;
            width: 100%;
			height: 40px;
			cursor: pointer;
			.title{
				flex: 1;
				font-size: 18px;
				font-weight: 400;
				color: #000000;
				margin-left: 10px;
				width: calc(100% - 130px);
			}
			.date{
				width: 120px;
				text-align: right;
				font-size: 18px;
				font-weight: 400;
				color: #666666;
			}
		}

		.signle:hover .title{
			color: #E61F26;
		}
		.signle:hover .date{
			color: #E61F26;
		}

	}





}

</style>
